// extracted by mini-css-extract-plugin
export default {"signature":"Signature_signature__jIRA8"};